var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3082",
    "data-name": "Group 3082",
    transform: "translate(-247 -60)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_560",
    "data-name": "Path 560",
    transform: "translate(247 60)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.5 22.75 C 8.495019912719727 22.75 5.669899940490723 21.57979965209961 3.545049905776978 19.4549503326416 C 1.420199990272522 17.33009910583496 0.25 14.50498008728027 0.25 11.5 C 0.25 8.495019912719727 1.420199990272522 5.669899940490723 3.545049905776978 3.545049905776978 C 5.669899940490723 1.420199990272522 8.495019912719727 0.25 11.5 0.25 C 14.50498008728027 0.25 17.33009910583496 1.420199990272522 19.4549503326416 3.545049905776978 C 21.57979965209961 5.669899940490723 22.75 8.495019912719727 22.75 11.5 C 22.75 14.50498008728027 21.57979965209961 17.33009910583496 19.4549503326416 19.4549503326416 C 17.33009910583496 21.57979965209961 14.50498008728027 22.75 11.5 22.75 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5 0.5 C 8.561800003051758 0.5 5.799449920654297 1.644199371337891 3.721830368041992 3.721830368041992 C 1.644199371337891 5.799449920654297 0.5 8.561800003051758 0.5 11.5 C 0.5 14.43819999694824 1.644199371337891 17.2005500793457 3.721830368041992 19.27816963195801 C 5.799449920654297 21.35580062866211 8.561800003051758 22.5 11.5 22.5 C 14.43819999694824 22.5 17.2005500793457 21.35580062866211 19.27816963195801 19.27816963195801 C 21.35580062866211 17.2005500793457 22.5 14.43819999694824 22.5 11.5 C 22.5 8.561800003051758 21.35580062866211 5.799449920654297 19.27816963195801 3.721830368041992 C 17.2005500793457 1.644199371337891 14.43819999694824 0.5 11.5 0.5 M 11.5 0 C 17.85127067565918 0 23 5.14872932434082 23 11.5 C 23 17.85127067565918 17.85127067565918 23 11.5 23 C 5.14872932434082 23 0 17.85127067565918 0 11.5 C 0 5.14872932434082 5.14872932434082 0 11.5 0 Z",
    stroke: "none",
    fill: "#878485"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3074",
    "data-name": "Group 3074",
    transform: "translate(250.661 65.86)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M128.175,13.4a1.657,1.657,0,0,1-.363-.709,1.461,1.461,0,0,1,2.824-.751,1.119,1.119,0,0,0,.068.239V12.6a3.548,3.548,0,0,1-.148.44,1.479,1.479,0,0,1-.887.76l-.115.037a.419.419,0,0,0-.093.007,1.444,1.444,0,0,1-.584-.025A1.559,1.559,0,0,1,128.175,13.4Z",
    transform: "translate(-115.32 -9.802)",
    fill: "#b6b7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M84.1,26.719a1.558,1.558,0,0,0,.709.411,1.444,1.444,0,0,0,.584.025.427.427,0,0,0,.093-.007c-.067.513-.147,1.025-.259,1.53a8.029,8.029,0,0,1-.908,2.448.163.163,0,0,1-.024.028H78.93V26.047a1.455,1.455,0,0,0,1.043-.437,1.961,1.961,0,0,0,.364.877,2.266,2.266,0,0,0,1.242.915,2.35,2.35,0,0,0,2.182-.374A2.2,2.2,0,0,0,84.1,26.719Z",
    transform: "translate(-71.244 -23.118)",
    fill: "#c5c9d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M18.372,26.4v5.1H13.015a6.863,6.863,0,0,1-.738-1.731,11.967,11.967,0,0,1-.292-1.246c-.063-.34-.1-.682-.155-1.027a.74.74,0,0,1,.1,0,1.488,1.488,0,0,0,.843-.122,2.144,2.144,0,0,0,.439-.306,2.3,2.3,0,0,0,1.071.682,2.352,2.352,0,0,0,2.35-.538A2.386,2.386,0,0,0,17.341,26a.123.123,0,0,1,.079.043,1.461,1.461,0,0,0,.944.353Z",
    transform: "translate(-10.679 -23.47)",
    fill: "#b6b7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M23.893,83h5.355v2.337a.158.158,0,0,0,.028.115c-.026.046-.063.032-.1.032H24.4c-.309,0-.507-.267-.508-.682C23.887,84.2,23.891,83.6,23.893,83Z",
    transform: "translate(-21.564 -74.918)",
    fill: "#878485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M78.907,85.542c-.032-.028-.028-.072-.028-.115V83.09h5.36v1.861c0,.341-.183.584-.434.592-.347.006-.694,0-1.041,0H79.019A.609.609,0,0,1,78.907,85.542Z",
    transform: "translate(-71.197 -75)",
    fill: "#b6b7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M2.542,14.09a2.67,2.67,0,0,1-.45.313,1.488,1.488,0,0,1-.843.122.743.743,0,0,0-.1,0,2.029,2.029,0,0,1-.571-.274A1.467,1.467,0,0,1,.058,12.72a1.41,1.41,0,0,1,1.18-1.08,1.444,1.444,0,0,1,1.656,1.1A1.428,1.428,0,0,1,2.6,14.016C2.581,14.04,2.564,14.067,2.542,14.09Z",
    transform: "translate(-0.011 -10.489)",
    fill: "#878485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M80.038,2.537A1.455,1.455,0,0,1,79,2.974V.047a1.411,1.411,0,0,1,1.223.66A1.447,1.447,0,0,1,80.16,2.4C80.123,2.448,80.063,2.477,80.038,2.537Z",
    transform: "translate(-71.307 -0.045)",
    fill: "#b6b7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M65.364.026V2.948A1.461,1.461,0,0,1,64.42,2.6c-.023-.019-.044-.045-.079-.043a1.129,1.129,0,0,0-.153-.2,1.425,1.425,0,0,1-.282-.974A1.461,1.461,0,0,1,64.863.112a1.071,1.071,0,0,1,.5-.086Z",
    transform: "translate(-57.679 -0.023)",
    fill: "#878485"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerator);
export default __webpack_public_path__ + "static/media/moderator.a69bb9c30a87dcb573425cc28d6db5ea.svg";
export { ForwardRef as ReactComponent };